import { useNavigate } from "react-router-dom";

// components
import NavItem from "./topnav/NavItem";

// images
import TopNavLogoImage from "../../images/components/topnav/topNavLogo.svg";


function TopNav() {
    const navigate = useNavigate();

    const downloadGLMP = () => {
        let isResp = window.confirm("Do you want to download the installation file?");
        if (isResp) {
            var url =
            "https://bgl-resources.s3.ap-northeast-2.amazonaws.com/installer/" +
            process.env.REACT_APP_LAUNCHER_INSTALL_FILE_NAME +
            ".exe";
            window.open(url, "_blank");
        }
    }

    return (
        <div className="TopNav">
            <div className="Logo">
                <img src={TopNavLogoImage} alt="mainpage logo" onClick={()=>navigate("/")} />
            </div>
            <div className="Menu">
                <NavItem
                    menu={{
                        name: "Pricing",
                        link: "/pricing"
                    }}
                    subMenuList={[]}
                />
                <NavItem
                    menu={{
                        name: "Resources",
                        link: "/resources"
                    }}
                    subMenuList={[
                        {
                            name: "BLOG",
                            link: "/resources/blog"
                        },
                        {
                            name: "Linked in",
                            link: "/resources/linked-in"
                        },
                        {
                            name: "Help center",
                            link: "/resources/help-center"
                        },
                        {
                            name: "Partner",
                            link: "/resources/partner"
                        }
                    ]}
                />
                {!localStorage.getItem("token") ?
                    <NavItem
                        menu={{
                            name: "Sign in",
                            link: "/sign-in"
                        }}
                        subMenuList={[]}
                    /> :
                    <NavItem
                        menu={{
                            name: localStorage.getItem("name"),
                            link: "/mypage"
                        }}
                        subMenuList={[]}
                    />
                }
                {!localStorage.getItem("token") && 
                    <NavItem
                        menu={{
                            name: "Sign up",
                            link: "/sign-up"
                        }}
                        subMenuList={[]}
                    />
                }
                <button className="Button-Download" onClick={downloadGLMP}>Free Download</button>
            </div>
        </div>
    );
}

export default TopNav;